import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
const MembershipProductEvaluationHandler = () => {
  const singleEventHandler = SingleEventHandler();
  return {
    evaluate: singleEventHandler.trigger,
    onEvaluation: singleEventHandler.listen,
    stopOnEvaluation: singleEventHandler.stopListening
  };
};
export default MembershipProductEvaluationHandler;